export default __webpack_public_path__ + "static/media/PursueClinical.3941bbdc.jpg";